import minutesToHours from "./minutesToHours";

export default function formatDuration(minutes: number) {
  if (minutes < 60) {
    return `${minutes}m`;
  }

  const hours = minutesToHours(minutes);
  const remaining = minutes - hours * 60;

  if (remaining > 0) {
    return `${hours}h ${remaining}m`;
  }

  return `${hours}h`;
}
